<script setup lang="ts">
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import VHorizontalNavigation from '@shared/component/VHorizontalNavigation/VHorizontalNavigation.vue';
import { type NavItem } from '@shared/component/VHorizontalNavigation/types';
import { useBreadcrumb } from '@menu-lib/breadcrumb/breadcrumb';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import routes from '../routes/contact.routes';

useBreadcrumb([{ name: 'Contact', link: '' }]);

const route = useRoute();

const navItems: NavItem<string>[] = routes.map((r) => ({
  key: r.path,
  label: String(r.meta?.title ?? ''),
  additionalFields: `/contact/${r.path}`,
  children: [],
}));

const activeNavItem = computed(() => {
  const match = navItems.find((item) => route.path.startsWith(item.additionalFields));
  return match?.key ?? 'medewerkers';
});
</script>

<template>
  <VPageContainer title="Contact" container-size="2xl">
    <VHorizontalNavigation compact :items="navItems" :active-nav-item="activeNavItem" />
    <RouterView v-slot="{ Component: RouteComponent }">
      <KeepAlive>
        <component :is="RouteComponent" />
      </KeepAlive>
    </RouterView>
  </VPageContainer>
</template>
